import React from "react";
import PropTypes from "prop-types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTags } from "@fortawesome/free-solid-svg-icons";

const EnterprisePricingInfo = ({ name, sku, showLicenseInfo }) => {
  return (
    <>
      <div className="enterprisePricing">
        {showLicenseInfo && (
          <>
            <p id="licenseInfo">
              This Product cannot be purchased as an individual license.
            </p>
          </>
        )}
        <div className="enterprisePricing">
          <a
            href={`/request-pricing/name=${name}sku=${sku}`}
            rel="origin-when-cross-origin"
            className="enterprisePricing__link"
          >
            <FontAwesomeIcon
              className="enterprisePricing__link__icon"
              icon={faTags}
              alt="tags icon"
            />
            Request an Enterprise Quote
          </a>
        </div>
      </div>
    </>
  );
};

EnterprisePricingInfo.propTypes = {
  name: PropTypes.string,
  sku: PropTypes.string,
  showLicenseInfo: PropTypes.bool
};

EnterprisePricingInfo.defaultProps = {
  name: null,
  sku: null,
  showLicenseInfo: false
};

export default EnterprisePricingInfo;
